var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        [
          _c(
            "el-main",
            [
              _c("div", { staticClass: "mx-auto" }, [
                _c("h3", [_vm._v("直接建立")]),
              ]),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.form,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "經銷商" } },
                    [
                      _c("selectCompany", {
                        attrs: {
                          filter_all: _vm.filter_all,
                          id: _vm.form.company_id,
                        },
                        on: {
                          "update:id": function ($event) {
                            return _vm.$set(_vm.form, "company_id", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "期別", prop: "period" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "如: 11202" },
                        model: {
                          value: _vm.form.period,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "period", $$v)
                          },
                          expression: "form.period",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "字軌", prop: "front" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "如: AA" },
                        model: {
                          value: _vm.form.front,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "front", $$v)
                          },
                          expression: "form.front",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "起始號碼", prop: "start" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "如: 00010001" },
                        model: {
                          value: _vm.form.start,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "start", $$v)
                          },
                          expression: "form.start",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "結束號碼", prop: "end" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "如: 00010010" },
                        model: {
                          value: _vm.form.end,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end", $$v)
                          },
                          expression: "form.end",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("form")
                            },
                          },
                        },
                        [_vm._v("立即建立")]
                      ),
                      _c("el-button", [_vm._v("取消")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("br"),
              _c("hr"),
              _c("div", { staticClass: "mx-auto" }, [
                _c("h3", [_vm._v("批次上傳")]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _c("h4", { staticClass: "h4" }, [
                                _vm._v("經銷商"),
                              ]),
                              _c("selectCompany", {
                                attrs: {
                                  id: _vm.form.company_id,
                                  filter_all: true,
                                },
                                on: {
                                  "update:id": function ($event) {
                                    return _vm.$set(
                                      _vm.form,
                                      "company_id",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.openSelectFile },
                            },
                            [_vm._v("點擊上傳檔案")]
                          ),
                          _c("a", { on: { click: _vm.downloadExample } }, [
                            _vm._v(" 點擊下載範例 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.sheetDialogVisible,
                    title: "請問是否要以下列資料新增發票？",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.sheetDialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.newInvoice } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "front", label: "字軌" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "start", label: "起始號碼" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "end", label: "結束號碼" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "period", label: "發票期別" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "wholesaler", label: "經銷商代號" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmUpload },
                    },
                    [_vm._v("確認上傳")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.cancelUpload },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
              _c("input", {
                ref: "sheetUploadInput",
                attrs: { type: "file", hidden: "" },
                on: { change: _vm.upload },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }